import React from 'react';
import { useTranslation } from 'react-i18next';
import { OpenStatusDropdownProvider } from 'components/tasks/TasksViewer/TaskStatusDropdown';
import { Objective } from 'services/objectives/types';
import { RangeSelectEvent } from 'utils/rangeSelection';
import ObjectiveCard from './ObjectiveCard';
import { sortObjectivesByDueDate } from './utils';
import styles from './ObjectivesBoard.module.css';

interface ObjectivesBoardProps {
  objectives?: Objective[] | null;
  onObjectiveClick: (objectiveId: string) => void;
  onObjectiveSelect: (
    objective: Objective,
    event?: RangeSelectEvent,
    displayedObjectives?: Objective[],
  ) => void;
  selectedObjectives: Objective[];
}

const ObjectivesBoard = ({
  objectives,
  onObjectiveClick,
  onObjectiveSelect,
  selectedObjectives,
}: ObjectivesBoardProps) => {
  const { t } = useTranslation();
  const sortedObjectives = sortObjectivesByDueDate(objectives);

  return (
    <OpenStatusDropdownProvider>
    <div className={styles.board}>
      {
        !sortedObjectives.length && (
          <div className={styles.emptyState}>
            {t('noObjectivesToDisplay')}
          </div>
        )
      }
      {
        sortedObjectives.map(objective => (
          <ObjectiveCard
            isSelected={!!selectedObjectives.find(selected => objective.id === selected.id)}
            key={objective.id}
            objective={objective}
            onClick={onObjectiveClick}
            onSelect={(selectedObjective, event) => onObjectiveSelect(
              selectedObjective,
              event,
              sortedObjectives,
            )}
          />
        ))
      }
    </div>
    </OpenStatusDropdownProvider>
  );
};

export default ObjectivesBoard;
